import { render, staticRenderFns } from "./AFGViewer.vue?vue&type=template&id=1d32086a&scoped=true"
import script from "./AFGViewer.vue?vue&type=script&lang=js"
export * from "./AFGViewer.vue?vue&type=script&lang=js"
import style0 from "./AFGViewer.vue?vue&type=style&index=0&id=1d32086a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32086a",
  null
  
)

export default component.exports